export enum UnitsOfTimeType {
  Millisecond = "Millisecond",
  Second = "Second",
  Minute = "Minute",
  Hour = "Hour",
  Day = "Day",
  Week = "Week",
  Month = "Month",
  Year = "Year"
}

